/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {EmojiEmptyCategoryPipe as Éµa} from './lib/pipes/emoji-empty-category.pipe';
export {EmojiFallback as Éµb} from './lib/pipes/emoji-fallback.pipe';